import React from 'react';
import { useTranslation } from 'react-i18next';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Utility } from '@swyftx/aviary/atoms/Typography';
import {
  CryptoLoanCalculator,
  LoansFAQ,
  LoansHowItWorks,
  LoansPutYourBitcoinToWork,
  LoansWhyChooseCBL,
  AccessCashBanner,
} from '@swyftx/features/loans/components';
import { ErrorBanner } from '@swyftx/features/loans/components/EducationPage/ErrorBanner/ErrorBanner';
import { useLoansRestrictionBanner } from '@swyftx/features/loans/hooks/useLoansRestrictionBanner';

import { observer } from 'mobx-react-lite';

type Props = {
  className?: string;
};

const LoansLandingPage: React.FC<Props> = observer(() => {
  const { t } = useTranslation('loans');
  const { errorType } = useLoansRestrictionBanner();
  const hasError = !!errorType;

  return (
    <FlexLayout
      direction='column'
      className='relative m-32 mx-auto max-w-6xl space-y-64 @container xs:px-32 xs:py-24 lg:px-0'
    >
      <ErrorBanner errorType={errorType} />
      <AccessCashBanner hasError={hasError} />
      <LoansPutYourBitcoinToWork />
      <LoansHowItWorks />
      <LoansWhyChooseCBL />
      <CryptoLoanCalculator hasError={hasError} />
      <LoansFAQ />
      <Utility className='text-center' variant='caption'>
        {t('disclaimer')}
      </Utility>
    </FlexLayout>
  );
});

export { LoansLandingPage };
